export default {
    modalQuickActionVariations: {
        title: 'Tekoäly',
        generateWithAi: 'Generoida tekoälyn avulla',
        improveWriting: 'Paranna kirjoitustaitoa',
        fixSpelling: 'Korjaa kirjoitusvirheet ja kielioppi',
        simplifyWriting: 'Yksinkertaista kirjoittaminen',
        makeLonger: 'Pidennä',
        makeShorter: 'Lyhennä',
        replaceText: 'Korvaa teksti',
        addBelow: 'Lisää alle',
        cancel: 'Peruuttaa',
        selectQuickActionTitle: 'Kerro tekoälylle, mitä tehdä seuraavaksi',
        regenerate: 'Uudistaa',
    },
};
